import { render, staticRenderFns } from "./MhRadio.vue?vue&type=template&id=01874de8&scoped=true&"
import script from "./MhRadio.vue?vue&type=script&lang=js&"
export * from "./MhRadio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01874de8",
  null
  
)

export default component.exports